export default "__VITE_ASSET__hA$_vGCY__"